import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import useEmblaCarousel from 'embla-carousel-react';
import { useTranslation } from '../../hooks/useTranslation';
import { useFilteredNavigation } from '../../utils/navigation';
import Icon from '../Icon/Icon';
import Button from '../common/Button';
import './MobileNavigation.scss';

const MobileNavigation = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { navigationItems } = useFilteredNavigation();

    const [emblaRef] = useEmblaCarousel({
        align: 'start',
        containScroll: 'trimSnaps',
        dragFree: true,
        skipSnaps: true
    });

    // Find the current navigation item to determine which create button to show
    const currentNavItem = navigationItems.find(item =>
        location.pathname === item.path ||
        location.pathname.startsWith(item.path + '/')
    );

    const handleCreateClick = () => {
        if (currentNavItem && currentNavItem.add_create_button) {
            navigate(`${currentNavItem.path}/create`);
        }
    };

    return (
        <nav className="mobile-navigation">
            <div className="embla" ref={emblaRef}>
                <div className="embla__container">
                    {navigationItems.map((item) => (
                        <div key={item.path} className="embla__slide">
                            <Link
                                to={item.path}
                                className={`mobile-nav-link ${
                                    location.pathname === item.path ||
                                    location.pathname.startsWith(item.path + '/')
                                        ? 'active'
                                        : ''
                                }`}
                            >
                                <Icon icon={item.icon} className="mobile-nav-icon" />
                                <span className="mobile-nav-label">{t(item.labelKey)}</span>
                            </Link>
                        </div>
                    ))}
                    {currentNavItem && currentNavItem.add_create_button && (
                        <div className="embla__slide">
                            <Button
                                onClick={handleCreateClick}
                                variant="primary"
                                size="small"
                                className="mobile-nav-create-button"
                            >
                                <Icon icon="plus" size="sm" />
                                {t('common.create')}
                            </Button>
                        </div>
                    )}
                    <div className="embla__slide">
                        <img src="/sloot_logo.svg" alt="Sloot Logo" className="nav-logo" width="50" />
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default MobileNavigation;